import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../../contexts/AuthContext";
import Loader from "../../../UI/Loader";
import StatComponent from "../StatComponent";
import { getStats } from "../../../SF";

const isDevelopment = process.env.NODE_ENV === "development";

const StatsThisLastMonth = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const context = useAuthContext();
  const user = context?.user;

  useEffect(() => {
    if (!context || !user) {
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getStats(context, "This & Last Month");
        setStats(result);
      } catch (error) {
        if (!isDevelopment && window.errorReporting) {
          window.errorReporting.captureException(error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [context, user]);

  if (!context || !user) {
    return null;
  }

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {stats ? (
            <StatComponent stats={stats} title="This Month vs Last Month" />
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};

export default StatsThisLastMonth;
